module.exports = __webpack_public_path__ + "assets/6c3f34e69921ff556168698c15de5c95.json";